import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationVariant } from '@components/notification/notification.constants';
import { ApiClientConstant, Table } from '@cureskin/api-client';
import { Store } from '@ngrx/store';
import { AppWebBridgeService } from '@services/app-web-bridge-service';
import { BroadcastService } from '@services/broadcast-service';
import { ConnectionService } from '@services/connection-service';
import { resetCacheByName } from '@services/connection-service/cache-interceptor';
import { CrossSellRegimenService } from '@services/cross-sell-regimen-service/cross-sell-regimen.service';
import { CurrentComponentService } from '@services/current-component';
import { EventLoggerService } from '@services/event-logger-service';
import { FirebaseAndBranchEvent } from '@services/event-logger-service/event-logger.constant';
import { ExperimentService } from '@services/experiment/experiment.service';
import { PrepaidDiscountVariant } from '@services/experiment/experiment.service.types';
import { LocalStorageService } from '@services/local-storage-service';
import { PaymentService } from '@services/payment-service';
import { PersonalisedPromotionsService } from '@services/personalised-promotions-service';
import { RazorpayService } from '@services/razorpay-service';
import { TimeService } from '@services/time-service';
import { UserService } from '@services/user';
import { WindowRefService } from '@services/window-ref-service';
import { CCODBottomSheetComponent } from '@shared/bottom-sheet-layouts/ccod-bottom-sheet/ccod-bottom-sheet.component';
import { CodHandlingFeeSheetComponent } from '@shared/bottom-sheet-layouts/cod-handling-fee-sheet/cod-handling-fee-sheet.component';
import { ConfirmCodOrderComponent } from '@shared/bottom-sheet-layouts/confirm-cod-order/confirm-cod-order.component';
import { PrepaidDiscountSheetComponent } from '@shared/bottom-sheet-layouts/prepaid-discount/prepaid-discount-sheet.component';
import { SharePaymentHowItWorksComponent } from '@shared/bottom-sheet-layouts/share-payment-how-it-works/share-payment-how-it-works.component';
import { SharePaymentLinkGeneratedComponent } from '@shared/bottom-sheet-layouts/share-payment-link-generated/share-payment-link-generated.component';
import { SharePaymentLinkSharedComponent } from '@shared/bottom-sheet-layouts/share-payment-link-shared/share-payment-link-shared.component';
import { fromActions } from '@store/actions';
import { OrderHelper } from 'client/helper/order-helper';
import { PaymentMethodsTranslations } from 'e2e/src/shared/constants';
import {AnimationOptions} from 'ngx-lottie';
import { Observable } from 'rxjs';

import { AllocatedRegimen } from '../../app-constant-types';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'user-order-payment',
  templateUrl: './user-order-payment.html',
  styleUrls: ['./user-order-payment.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

export class UserOrderPaymentComponent implements OnDestroy, OnInit {
  @ViewChild('paymentPage') paymentPage: ElementRef;
  @ViewChild('couponInput') couponInput: ElementRef;

  order: any;
  user: any;
  discount: number;
  razorpay: any;
  paytmConfig: any;
  paytmServerUrl: string;
  selectedPaymentMode: string;
  orderSP: number = 0;
  orderMRP: number;
  orderActualSP: number;
  orderBeforeOfferPrice: number;
  paymentGateways: any = {
    RAZORPAY: ['CARD', 'WALLET', 'NET_BANKING', 'UPI'],
    PAYTM: ['PAYTM'],
    COD: ['COD'],
    CCOD: ['COD'],
    PAY_PAL: ['PAY_PAL'],
  };
  walletBalance: number;
  paymentMethods: Array<{ title: string, mode: string, img?: string, desc?: string }> = [];
  forceRemoveCODOption: boolean = false;
  appliedCoupon: any;
  appliedWalletBalance: any;
  couponLoading: boolean = false;
  paymentProcessing: boolean = false;
  couponCode: string = '';
  couponExperimentActive: boolean = false;
  razorpayNativePayment: boolean = false;
  orderSummary: any = {};
  showOrderDetail: boolean;
  isPrepaidDiscountEnabled: boolean = false;
  showPrepaidDiscountInfo: boolean = false;
  prepaidDiscountCoupon: string = 'PREPAID100';
  prepaidDiscountKey: string = 'prepaid_offer';
  paymentMethodsTranslations: any;
  paymentMethodsAvailable: Array<any> = [
    {
      title: 'UPI',
      mode: AppConfig.Shared.Payment.paymentModes.UPI,
      img: 'https://assets.cureskin.com/img/app/upi.svg',
    },
    {
      title: 'Credit/Debit Card',
      mode: AppConfig.Shared.Payment.paymentModes.CARD,
      img: 'https://assets.cureskin.com/img/app/card.svg',
    },
    {
      title: 'Netbanking',
      mode: AppConfig.Shared.Payment.paymentModes.NET_BANKING,
      img: 'https://assets.cureskin.com/img/app/netbanking.svg',
    },
    {
      title: 'PayTm',
      mode: AppConfig.Shared.Payment.paymentModes.PAYTM,
      img: 'https://assets.cureskin.com/img/app/Paytm.svg',
    },
    {
      title: 'Mobile Wallets',
      mode: AppConfig.Shared.Payment.paymentModes.WALLET,
      img: 'https://assets.cureskin.com/img/app/wallet.svg',
    },
    {
      title: 'Cash On  Delivery',
      mode: AppConfig.Shared.Payment.paymentModes.COD,
      img: 'https://assets.cureskin.com/img/app/rupee.svg',
    },
  ];
  banners: Array<any> = [];
  enableOtherPayments: boolean = false;
  offerTimer: any = {};
  popUp: { open: boolean, type?: 'ORDER_SUMMARY' | 'COD_CONFIRMATION', data?: any, orderData?: any } = { open: false };
  experiments: any[];
  payment: any;
  paymentSecretKey: string;
  showCouponsSection: boolean = false;
  loading: boolean;
  coupons: any;
  isUPISelected: boolean = true;
  isPaidUser: boolean = false;
  interval: any;
  showCCODCharge: boolean = false;
  CCODInfo: any = {};
  cashBalance: any;
  startTimer:number;
  disableCod: boolean = false;
  isFirstOrder: boolean;
  isRegimenOrder: boolean;
  isCCODNotIncluded: boolean;
  isCodHandlingFeeEnabled: boolean;
  regimens: Array<AllocatedRegimen>;
  orderRegimen: AllocatedRegimen;
  codHandlingFee: number = 0;
  showCodConfirmationBottomSheet: boolean = false;
  crossSellRegimenV2Experiment: any;
  crossSellDiscountAmount: number;
  showNewCrossSellDiscountDisclaimer: boolean = false;
  centralizedPricingExpVariants: any;
  codFeeExpVariant: any;
  showApplyCashUI: boolean = false;
  shouldShowWalletOrCashSection: boolean = false;
  applyCashSelected: boolean = false;
  showConfettiAnimation: boolean = false;
  options: AnimationOptions = {
    path: '/assets/animation.json',
  };
  sharePaymentLinkEnabled: boolean = false;
  // share_payment_link variant: show the "Can't Pay Online?" nudge on back-press.
  backPopupEnabled: boolean = false;
  // Tracks that the user saw and dismissed the CCOD fee popup this visit (gate for the back-press nudge).
  ccodPopupSeen: boolean = false;
  isIOSDevice: boolean = false;

  constructor(private readonly broadcast: BroadcastService,
    private readonly route: ActivatedRoute,
    private readonly conn: ConnectionService,
    private readonly razorpayService: RazorpayService,
    private readonly windowRef: WindowRefService,
    private readonly eventLogger: EventLoggerService,
    private readonly http: HttpClient,
    public readonly appConfig: AppConfig,
    private readonly router: Router,
    private readonly zone: NgZone,
    private readonly appWebBridgeService: AppWebBridgeService,
    private readonly currentComponent: CurrentComponentService,
    private readonly locationService: Location,
    private readonly store: Store,
    private readonly bottomSheet: MatBottomSheet,
    private readonly paymentService: PaymentService,
    private readonly changeDetection: ChangeDetectorRef,
    private readonly localStorage: LocalStorageService,
    private readonly orderHelper: OrderHelper,
    private readonly timeService: TimeService,
    private readonly crossSellRegimenService: CrossSellRegimenService,
    public readonly experimentService: ExperimentService,
    private readonly personalisedPromotionsService: PersonalisedPromotionsService,
    private readonly userService: UserService,
  ) {
    resetCacheByName('fetchOrders');
    this.currentComponent.set(this);
    this.razorpayService.initialize();
  }

  /**
   * 1. Fetches the order by calling 'checkoutAndCreateOrder' api, which won't recreate order if exists. It returns the order data.
   * 2. Check if order stage is valid to visit the payment page. only INITIAL, PAYMENT_PENDING stage order are allowed.
   */
  async ngOnInit(): Promise<any> {
    this.appWebBridgeService.setStatusBarColor('cure/accentLight');
    this.startTimer = new Date().getTime();
    await this.detectDeviceOS();
    this.user = this.conn.getActingUser();
    this.paymentMethodsTranslations = PaymentMethodsTranslations;
    this.regimens = await this.conn.fetchRegimens(null, true);
    try {
      const orderId = this.route.snapshot.params.id;
      const checkoutPayload = this.buildCheckoutPayloadWithStoredUseCureSkinCash(orderId);
      this.order = await this.conn.checkoutAndCreateOrder(checkoutPayload);
      await this.checkStatusOfOrder();
    } catch (error) {
      this.broadcast.broadcast('NOTIFY', { message: error.message });
      this.back();
      return;
    }
    this.getPaytmServerUrl();
    this.isPaidUser = [
      this.appConfig.Shared.User.OrderState.PROCESSING,
      this.appConfig.Shared.User.OrderState.DELIVERED,
    ].includes(this.user.get('orderState'));
    await this.processOrderData();
    // Initialize applyCashSelected based on whether wallet balance is already applied
    this.applyCashSelected = !!this.appliedWalletBalance;
    this.checkForPaymentServices();
    this.setEventOnProductsOrder();
    this.setEventOnRegimenOrder();
    const time = new Date().getTime() - this.startTimer;
    this.eventLogger.trackEvent('payment_page_loading_time', { timeInMilliSec: time, userId: this.user.id });
    this.determineCrossSellDiscountDisclaimer();
    if (this.isPrepaidDiscountEnabled) {
      const hasUserAlreadySeenThePrepaidOffer = this.localStorage.getValue(this.prepaidDiscountKey);
      if (hasUserAlreadySeenThePrepaidOffer) {
        this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'online_discount_preapplied' }));
        await this.applyPrepaidCoupon();
      }
      this.prepaidDiscountInfoLogic();
    }
    this.changeDetection.detectChanges();

    const eventPayload = {
      pageName: 'payment_page_visited',
      isCODEnabled: this.order?.get('paymentGateway').includes(this.appConfig.Shared.Payment.paymentModes.COD),
      isCCODEnabled: this.order?.get('paymentGateway').includes(this.appConfig.Shared.Payment.paymentModes.CCOD),
      orderState: this.user.get('orderState'),
    };
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify(eventPayload), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
  }

  determineCrossSellDiscountDisclaimer(): void {
    const orderRegimen = this.order?.get('regimen');
    const regimenId: string = orderRegimen?.id;
    const regimenData = this.regimens?.find(regimen => regimen.objectId === regimenId);

    if (!regimenData) {
      this.showNewCrossSellDiscountDisclaimer = false;
      this.crossSellDiscountAmount = 0;
      return;
    }

    const selectedVariantId = regimenData.selectedVariantId;
    const variantsMap = this.centralizedPricingExpVariants?.[regimenData.class] ?? {};
    const centralVariant = selectedVariantId ? variantsMap[selectedVariantId] : variantsMap?.variant_1499;

    if (!centralVariant) {
      this.showNewCrossSellDiscountDisclaimer = false;
      this.crossSellDiscountAmount = 0;
      return;
    }

    const crossSellDiscount = this.crossSellRegimenV2Experiment?.variant[regimenData.class]?.discount;
    const regimenPriceDiff = centralVariant.fixedPrice - regimenData.fixedPrice;
    const delta: number = regimenPriceDiff - crossSellDiscount;

    if (delta === 0) {
      const { showBanner, discount }: {
        showBanner: boolean;
        discount: number;
      } = this.crossSellRegimenService.evaluateCrossSellProps(
        this.regimens, this.crossSellRegimenV2Experiment, true, this.order
      );
      this.showNewCrossSellDiscountDisclaimer = showBanner;
      this.crossSellDiscountAmount = discount;
    }
  }

  prepaidDiscountInfoLogic(): void {
    const prepaidState = this.doesOrderHasPrepaidCouponApplied();
    const hasUserAlreadySeenThePrepaidOffer = this.localStorage.getValue(this.prepaidDiscountKey);
    this.showPrepaidDiscountInfo = prepaidState || hasUserAlreadySeenThePrepaidOffer;
  }

  getTranslatedString(title: string): string {
    const getTranslatedString = this.paymentMethodsTranslations[title];
    const userLanguage = this.user.get('languagePreference');
    if (getTranslatedString && userLanguage && userLanguage !== 'en') {
      return getTranslatedString[userLanguage];
    }
    return title;
  }

  async detectDeviceOS(): Promise<void> {
    const os = await this.appWebBridgeService.requestOSInformation();
    this.isIOSDevice = os === 'iOS';
  }

  checkForPaymentServices(): void {
    const chargesAndDiscounts = this.order?.get('chargesAndDiscounts');
    if (chargesAndDiscounts && chargesAndDiscounts.length) {
      this.CCODInfo = chargesAndDiscounts.find(
        (each: any): any => each.description === this.appConfig.Shared.Payment.Charges.COD_PROCESSING_CHARGES);
      this.showCCODCharge = true;
    }
  }

  /**
   * 1. Process the experiments.
   * 2. Process valid payment gateways for the order.
   * 3. Process total, discount, coupons, walletBalance of the order.
   * 4. If order amount is 0, then we by default initiate a online order.
   * 5. Else waits for payment selection and sets UPI as default payment option.
   *
   */
  async processOrderData(paymentMethod: any = ''): Promise<any> {
    this.cashBalance = await this.conn.fetchCashBalance();
    await this.processExperiments();
    await this.fetchCoupons();
    this.processPaymentGateways();
    if (this.disableCod) {
      this.paymentMethods = this.paymentMethodsAvailable.filter((paymentMethod:any):any => (
        paymentMethod.mode !== this.appConfig.Shared.Payment.paymentModes.COD));
    } else {
      this.paymentMethods = this.paymentMethodsAvailable;
    }
    this.orderMRP = this.order.get('actualPrice');
    // To make the MRP uniform across the app
    await this.newVariantDiscountCalculation();
    this.orderSP = this.order.get('amount') - (this.order.get('paidAmount') || 0);
    this.orderBeforeOfferPrice = this.order.get('orderBeforeOfferPrice');
    this.walletBalance = this.order.get('walletAmount');
    this.calculateCouponDiscount();
    if (this.appliedWalletBalance) {
      let balance = this.walletBalance - (this.appliedWalletBalance.amount || 0);
      if (balance < 0) balance = 0;
      this.walletBalance = balance;
    }
    if (this.orderSP === 0) {
      await this.selectPaymentMethod(this.appConfig.Shared.Order.PaymentType.ONLINE);
    } else if (!paymentMethod) this.selectedPaymentMode = this.appConfig.Shared.Payment.paymentModes.UPI;
    else this.selectedPaymentMode = paymentMethod;
    this.updateShowApplyCashUI();
    this.updateWalletOrCashUI();
  }

  public updateShowApplyCashUI(): void {
    const type = this.order?.get('type');
    const isProductOrder = type === this.appConfig.Shared.Order.Type.PRODUCT;
    const isRegimenOrder = type === this.appConfig.Shared.Order.Type.REGIMEN;
    this.showApplyCashUI = !!this.experimentService.applyCashExperiment && (isProductOrder || isRegimenOrder);
  }

  public updateWalletOrCashUI(): void {
    const walletPositive = (this.walletBalance || 0) > 0;
    const hasAppliedCash = !!this.experimentService?.applyCashExperiment
      && (this.appliedWalletBalance?.amount || 0) > 0;
    this.shouldShowWalletOrCashSection = (walletPositive || hasAppliedCash) && this.showApplyCashUI;
  }

  private buildCheckoutPayloadWithStoredUseCureSkinCash(orderId: string): any {
    const checkoutPayload: any = { orderId };
    // Preserve / control useCureSkinCash only when applyCash experiment is ON
    if (this.experimentService.applyCashExperiment) {
      const storedUseCureSkinCash = sessionStorage.getItem(`useCureSkinCash_${orderId}`);
      if (storedUseCureSkinCash === 'true' || storedUseCureSkinCash === 'false') {
        // Use the user's previously chosen value
        checkoutPayload.useCureSkinCash = storedUseCureSkinCash === 'true';
      } else {
        // No session key present: when experiment is ON, default to NOT applying cash on refresh
        checkoutPayload.useCureSkinCash = false;
      }
    }
    return checkoutPayload;
  }

  async newVariantDiscountCalculation(): Promise<void> {
    if (this.order.get('type') === 'REGIMEN' && this.order.get('regimen')) {
      this.orderRegimen = await this.conn.findRegimenById(this.order.get('regimen')?.id);
      if (this.orderRegimen.fixedPriceMRP) {
        this.orderMRP = this.orderRegimen.fixedPriceMRP;
      }
    }
  }

  /**
   * 1. 'show_coupon_code' - controls whole coupon feature's visibility.
   * 2. 'checkout_banner' - controls banners, show banners mentioned in exp.variants.
   * 3. 'paypal_offer_banner' - add paypal offer banner to existing banners & adds PAYPAL as one of payment option.
   * 4. 'razorpay_native_payment' - opens NATIVE razorpay sdk, else WEB sdk.
   * 5. 'offer_timer_throughout_checkout' - shows offer discount timer.
   */
  async processExperiments(): Promise<void> {
    this.experiments = await this.conn.findUserActiveExperiments();
    this.experiments.forEach(async (experiment: any): Promise<void> => {
      if (experiment.key === 'checkout_banner') {
        this.banners.push(...experiment.variant.banners);
      } else if (experiment.key === 'paypal_offer_banner') {
        this.banners.push({ image: experiment.variant.imageLink });
        this.paymentMethodsAvailable.unshift({
          title: 'PayPal',
          mode: this.appConfig.Shared.Payment.paymentModes.PAY_PAL,
          img: 'https://assets.cureskin.com/img/app/payPal.svg',
          desc: experiment.variant.text || '50% upto to ₹500. For first-time PayPal users only.',
        });
      } else if (experiment.key === 'razorpay_native_payment') {
        this.razorpayNativePayment = true;
      } else if (experiment.key === 'offer_timer_throughout_checkout') {
        const timeLeft: any = (new Date(Number(experiment.variant.time)).getTime() - new Date().getTime());
        if (timeLeft > 0) {
          this.offerTimer = { endTime: timeLeft,
            title: experiment.variant.title[this.user.get('languagePreference') || this.appConfig.Shared.Languages.EN] };
        }
      } else if (this.shouldEnableCodHandlingFee(experiment.key)) {
        const codHandlingFeeData = this.order?.get('chargesAndDiscounts')?.find(
          (item: any):boolean => item.description === this.appConfig.Shared.Payment.Charges.COD_HANDLING_FEE);
        if (codHandlingFeeData) {
          this.codHandlingFee = codHandlingFeeData.amount;
          this.isCodHandlingFeeEnabled = true;
          if (experiment.key === 'cod_handling_fees_retention') {
            this.codFeeExpVariant = experiment.variant;
          }
          this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'COD_handling_fee_subtext_shown' }));
        }
      } else if (experiment.key === 'double_confirm_cod_order' && this.orderHelper.isOrderTypeRegimen(this.order?.get('type'))) {
        this.showCodConfirmationBottomSheet = true;
      } else if (experiment.key === 'cross_sell_regimen_v2') {
        this.crossSellRegimenV2Experiment = experiment;
      } else if (experiment.key === 'centralised_regimen_variant_pricing') {
        this.centralizedPricingExpVariants = experiment.variant;
      } else if (experiment.key === 'share_payment_link') {
        const isRegimenOrder = this.orderHelper.isOrderTypeRegimen(this.order?.get('type'));
        const isAcquisitionUser = !!this.user && this.userService.isUnpaidUser(this.user);
        this.sharePaymentLinkEnabled = isRegimenOrder && isAcquisitionUser;
        this.backPopupEnabled = this.sharePaymentLinkEnabled && !!experiment.variant?.back_popup;
      }
    });
    await this.processPrepaidDiscountExperiment();
  }

  async shouldEnablePrepaidDiscount(variant: PrepaidDiscountVariant): Promise<boolean> {
    this.isRegimenOrder = this.order?.get('type') === this.appConfig.Shared.Order.Type.REGIMEN;
    this.isFirstOrder = this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.NEW_USER;
    this.isCCODNotIncluded = !this.order?.get('paymentGateway').includes(this.appConfig.Shared.Payment.paymentModes.CCOD);

    const isEligible = this.isRegimenOrder && !this.isPaidUser && this.isFirstOrder && this.isCCODNotIncluded;
    if (!isEligible) return false;

    const shouldCheckForShiprocketPromotion = !!variant?.shipRocket;
    if (!shouldCheckForShiprocketPromotion) return true;

    return this.hasShiprocketPromotion();
  }

  private async hasShiprocketPromotion(): Promise<boolean> {
    resetCacheByName('getPersonalisedPromotions');
    const promotions = await this.personalisedPromotionsService.loadPersonalisedPromotions();
    return promotions.includes(ApiClientConstant.UserExtraInformation.PersonalisedPromotions.SHIPROCKET);
  }

  private async processPrepaidDiscountExperiment(): Promise<void> {
    const experiment = this.experimentService.prepaidDiscountExperiment;
    if (!experiment) return;

    const isEligible = await this.shouldEnablePrepaidDiscount(experiment.variant);
    if (!isEligible) return;

    this.isPrepaidDiscountEnabled = experiment.enable;
    this.prepaidDiscountCoupon = experiment.variant.couponCode;
  }

  shouldEnableCodHandlingFee(experimentKey: string): boolean {
    const isAcquisitionExperiment = experimentKey === 'cod_handling_fees';
    const isRetentionExperiment = experimentKey === 'cod_handling_fees_retention';
    const isRegimenOrder = this.order?.get('type') === this.appConfig.Shared.Order.Type.REGIMEN;
    const isProductOrder = this.order?.get('type') === this.appConfig.Shared.Order.Type.PRODUCT;
    const isCCODIncluded = this.order?.get('paymentGateway').includes(this.appConfig.Shared.Payment.paymentModes.CCOD);
    if (isCCODIncluded) return false;

    return (isAcquisitionExperiment || isRetentionExperiment) && (isRegimenOrder || isProductOrder);
  }

  async fetchCoupons(): Promise<void> {
    this.coupons = JSON.parse(JSON.stringify(await this.conn.findAllActiveCoupons()));
  }

  /**
   * To track product orders
   */
  setEventOnProductsOrder(): void {
    if (this.order?.get('type') === this.appConfig.Shared.Order.Type.PRODUCT) {
      this.eventLogger.trackInFirebaseAndBranch('PRODUCT_VIEWED');
    }
  }
  /**
 * To track retention regimen orders
 */
  setEventOnRegimenOrder(): void {
    if (this.order?.get('type') === this.appConfig.Shared.Order.Type.REGIMEN && this.user.isPaid()) {
      this.eventLogger.trackInFirebaseAndBranchForClass(FirebaseAndBranchEvent.REGIMEN_VIEWED, this.orderRegimen?.class);
    }
  }

  /**
   * 1. Filter the payment gateways mentioned in order and shows only those for this specific order.
   * 2. When RAZORPAY is one of the allowed gateway, then only we show OTHER payments section in UI (which will open razorpay home).
   */
  processPaymentGateways(): void {
    this.removeCODOptionIfDietOrder();
    const allowedPaymentModes = this.getAllowedPaymentModes();
    this.filterPaymentMethods(allowedPaymentModes);
    this.enableOtherPayments = this.isRazorpayEnabled();
  }

  private removeCODOptionIfDietOrder(): void {
    if (this.order?.get('serviceInfo')) {
      const isDietOrder = this.order?.get('serviceInfo')?.some((service: any): any => service.type
    === this.appConfig.Shared.Order.Type.DIET_CONSULTATION);
      if (isDietOrder) {
        this.disableCod = true;
        this.logCleverTapEventForDisableCOD();
      }
    }
  }

  private logCleverTapEventForDisableCOD(): void {
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'cod_not_available_shown' }));
  }

  private getAllowedPaymentModes(): string[] {
    const orderPaymentGateways: string[] = this.order.get('paymentGateway') || Object.keys(this.paymentGateways);
    const allowedPaymentModes = [];
    orderPaymentGateways.forEach((each: any): void => {
      allowedPaymentModes.push(...(this.paymentGateways[each] || []));
    });
    this.disableCod = !(orderPaymentGateways.includes('COD') || orderPaymentGateways.includes('CCOD'));
    if (this.disableCod) this.logCleverTapEventForDisableCOD();
    return allowedPaymentModes;
  }

  private filterPaymentMethods(allowedPaymentModes: string[]): void {
    this.paymentMethodsAvailable = this.paymentMethodsAvailable.filter((each: any): boolean => (
      each.mode === this.appConfig.Shared.Payment.PaymentSource.COD || allowedPaymentModes.includes(each.mode)
    ));
  }

  private isRazorpayEnabled(): boolean {
    const orderPaymentGateways: string[] = this.order.get('paymentGateway') || Object.keys(this.paymentGateways);
    return orderPaymentGateways.includes(this.appConfig.Shared.Payment.PaymentSource.RAZORPAY);
  }

  applyCouponCode(code: string): void {
    this.couponCode = code;
  }

  getPaytmServerUrl(): void {
    switch (this.windowRef.nativeWindow.location.hostname) {
      case 'app.cureskin.com': {
        this.paytmServerUrl = 'https://securegw.paytm.in/theia/processTransaction';
        break;
      }
      default: {
        this.paytmServerUrl = 'https://pguat.paytm.com/oltp-web/processTransaction';
        break;
      }
    }
  }

  selectPaymentMethod(paymentMode: string): void {
    if (this.loading) return;
    if (this.disableCod && paymentMode === this.appConfig.Shared.Payment.paymentModes.COD) return;
    this.selectedPaymentMode = paymentMode;
    this.updateOrderPrice();
    this.discount = Math.floor(((this.orderMRP - this.orderSP) * 100) / this.orderMRP);
    this.eventLogger.cleverTapEvent('paymentMode', JSON.stringify({ paymentMode: this.selectedPaymentMode }));
    this.appWebBridgeService.logEventInBranchAndFirebaseFromiOS({
      branch: { name: 'clickPaymentTypeSelected' },
      firebase: { name: 'clickPaymentTypeSelected' },
    });
    if (this.isPrepaidDiscountEnabled) {
      if (paymentMode !== this.appConfig.Shared.Payment.paymentModes.UPI) {
        this.removePrepaidCouponIfNotUPI(paymentMode);
      } else {
        const hasUserAlreadySeenThePrepaidOffer = this.localStorage.getValue(this.prepaidDiscountKey);
        if (hasUserAlreadySeenThePrepaidOffer) {
          this.applyPrepaidCoupon();
        }
      }
    }
  }

  async applyPrepaidCoupon(): Promise<void> {
    const isUPIPayment = this.selectedPaymentMode === this.appConfig.Shared.Payment.paymentModes.UPI;
    if (!this.doesOrderHasPrepaidCouponApplied() && isUPIPayment) {
      this.loading = true;
      this.changeDetection.detectChanges();
      this.applyCouponCode(this.prepaidDiscountCoupon);
      await this.applyCoupon(this.selectedPaymentMode, true);
      if (this.doesOrderHasPrepaidCouponApplied()) {
        this.notify(`Amount updated to ${this.orderSP}`, NotificationVariant.ABOVE_STICKY_FOOTER);
      }
      this.loading = false;
      this.changeDetection.detectChanges();
    }
  }

  async removePrepaidCouponIfNotUPI(paymentMode: string): Promise<void> {
    this.loading = true;
    if (this.doesOrderHasPrepaidCouponApplied()) {
      const orderId = this.route.snapshot.params.id;
      this.order = await this.conn.removeDiscountCoupon(this.prepaidDiscountCoupon, orderId);
      const checkoutPayload = this.buildCheckoutPayloadWithStoredUseCureSkinCash(orderId);
      this.order = await this.conn.checkoutAndCreateOrder(checkoutPayload);
      this.orderSP = this.order.get('amount') - (this.order.get('paidAmount') || 0);
      this.calculateCouponDiscount();
      this.notify(`Amount updated to ${this.orderSP}`, NotificationVariant.ABOVE_STICKY_FOOTER);
    }
    this.loading = false;
    delete this.appliedCoupon;
    this.changeDetection.detectChanges();
  }

  doesOrderHasPrepaidCouponApplied(): boolean {
    const appliedCoupons = this.order?.get('couponInfo');
    const hasPrepaidCouponApplied = appliedCoupons?.some((coupon: any): boolean => coupon?.code === this.prepaidDiscountCoupon);
    return hasPrepaidCouponApplied;
  }

  async checkStatusOfOrder(): Promise<any> {
    const paymentPendingStages = [this.appConfig.Shared.Order.Stage.INITIAL, this.appConfig.Shared.Order.Stage.ONLINE_PAYMENT_PENDING];
    if (paymentPendingStages.includes(this.order.get('stage'))) {
      return;
    }
    this.back();
  }

  /**
   * 1. Initiates the payment foe selected payment mode.
   * 2. Backend gives the payment object.
   * 3. If order price is 0, we show order success page.
   * 4. If payment has 'preCondition' mentioned of type (COD_CONFIRMATION_FEE), then it shows a popup asking for COD fee.
   * 5. Else opens the payment page.
   */
  async placeOrder(): Promise<void> {
    if (this.couponLoading) return;
    this.loading = true;
    this.logPurchaseEvents();
    const isCODPayment = this.selectedPaymentMode === this.appConfig.Shared.Payment.paymentModes.COD;
    if (isCODPayment && this.isPrepaidDiscountEnabled && !this.localStorage.getValue(this.prepaidDiscountKey) && this.isFirstOrder) {
      this.localStorage.setValue(this.prepaidDiscountKey, true);
      this.showPrepaidDiscountInfo = true;
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ pageName: 'online_discount_popup_shown' }));
      this.bottomSheet.open(PrepaidDiscountSheetComponent, {
        data: {
          orderSP: this.orderSP,
          userLanguage: this.user?.get('languagePreference'),
          prepaidClick: async (): Promise<void> => {
            this.loading = true;
            this.bottomSheet.dismiss();
            this.selectedPaymentMode = this.appConfig.Shared.Payment.paymentModes.UPI;
            await this.applyPrepaidCoupon();
            this.prepaidDiscountInfoLogic();
            this.loading = false;
            this.changeDetection.detectChanges();
          },
          codClick: (): void => {
            this.initiateOrderPayment();
            this.bottomSheet.dismiss();
            this.loading = false;
            this.changeDetection.detectChanges();
          },
          onDismiss: async (): Promise<void> => {
            this.loading = true;
            this.selectedPaymentMode = this.appConfig.Shared.Payment.paymentModes.UPI;
            await this.applyPrepaidCoupon();
            this.prepaidDiscountInfoLogic();
            this.loading = false;
            this.changeDetection.detectChanges();
          },
        },
        disableClose: true,
      });
    } else if (!this.paymentService.getCodHandlingFeePopupState() && this.isCodHandlingFeeEnabled && isCODPayment) {
      this.paymentService.setcodHandlingFeePopupShown();
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ pageName: 'COD_handling_fee_popup_shown' }));
      this.bottomSheet.open(CodHandlingFeeSheetComponent, {
        data: {
          charges: this.codHandlingFee,
          orderSP: this.orderSP,
          userLanguage: this.user?.get('languagePreference'),
          isPaidUser: this.isPaidUser,
          codFeeExpVariant: this.codFeeExpVariant,
          handleOnlinePayment: (): void => {
            this.loading = true;
            this.bottomSheet.dismiss();
            this.selectedPaymentMode = this.appConfig.Shared.Payment.paymentModes.UPI;
            this.updateOrderPrice();
            this.loading = false;
            this.changeDetection.detectChanges();
          },
          handleCodPayment: (): void => {
            this.loading = true;
            this.bottomSheet.dismiss();
            this.updateOrderPrice();
            this.initiateOrderPayment();
            this.bottomSheet.dismiss();
            this.changeDetection.detectChanges();
          },
          onDismiss: (): void => {
            this.loading = false;
            this.changeDetection.detectChanges();
          },
        },
      });
      this.loading = false;
    } else if (isCODPayment && this.showCodConfirmationBottomSheet) {
      const confirmOrderBottomSheetRef = this.bottomSheet.open(ConfirmCodOrderComponent, {
        data: {
          orderSp: this.orderSP,
          confirmCodOrder: (): void => {
            this.initiateOrderPayment();
          },
          payOnline: (): void => {
            this.selectedPaymentMode = this.appConfig.Shared.Payment.paymentModes.UPI;
          },
          backdropClass: 'bottomsheet-blur-overlay-sm',
        },
      });
      this.handleBottomSheetDismiss(confirmOrderBottomSheetRef);
    } else {
      await this.initiateOrderPayment();
    }
    this.localStorage.setValue('stopRegimenRedirection', JSON.stringify(true));
  }

  public async initiateOrderPayment(): Promise<void> {
    this.loading = true;
    const { COD, ONLINE }: { COD: string; ONLINE: string } = this.appConfig.Shared.Order.PaymentType;
    const payload = {
      orderId: this.order.id,
      gateway: this.selectedPaymentMode.toLowerCase(),
      customTab: this.appWebBridgeService.isCustomTabSupported(),
      paymentType: this.selectedPaymentMode === COD ? COD : ONLINE,
    };
    try {
      const result = await this.conn.initiateOrderPayment(payload);
      this.loading = false;
      this.payment = result?.payment;
      this.paymentSecretKey = result?.key;
      if (this.orderSP === 0) {
        this.moveToSuccessPage();
      } else {
        this.handleOrderPayment();
      }
    } catch (error: any) {
      this.loading = false;
      this.eventLogger.logError(error);
      this.notify('Some issue with the payment. Contact Team for further queries.');
    }
  }

  /**
   * Updates order pricing based on payment mode and adds COD handling fee if applicable.
   * For product orders with COD, updates both orderMRP and orderSP.
   */
  public updateOrderPrice(): void {
    const isCodWithFee = this.isCodHandlingFeeEnabled && this.isPaymentModeCOD();
    const actualPrice = this.order.get('actualPrice');
    const orderAmount = this.order.get('amount');
    const paidAmount = this.order.get('paidAmount') || 0;

    if (this.isProductOrder() && isCodWithFee) {
      this.orderMRP = actualPrice + this.codHandlingFee;
      this.orderSP = orderAmount + this.codHandlingFee;
    } else if (!this.isProductOrder() && isCodWithFee) {
      this.orderSP = orderAmount + this.codHandlingFee;
    } else {
      this.orderSP = orderAmount - paidAmount;
    }
  }

  public logPurchaseEvents(): void {
    this.eventLogger.trackInParse(`CLICK_BUY_${this.selectedPaymentMode}`, ApiClientConstant.Event.Type.ORDER);
    this.eventLogger.cleverTapEvent('paymentPageOpened', JSON.stringify({
      MRP: this.order?.get('actualPrice'),
      FinalPrice: this.order?.get('amount'),
      method: this.selectedPaymentMode,
      Orderid: this.order?.id,
      orderType: this.order?.get('type'),
    }));
    this.appWebBridgeService.logEventInBranchAndFirebaseFromiOS({
      branch: { name: 'clickOnPay' },
      firebase: { name: 'clickOnPay' },
    });
  }

  private handleOrderPayment(): void {
    if (this.payment
        && this.payment.get('preCondition')
        && this.payment.get('preCondition').includes(this.appConfig.Shared.Payment.PreCondition.COD_CONFIRMATION_FEE)) {
      this.showCodConfirmationFeePopup();
    } else {
      this.openPayment();
    }
    this.changeDetection.detectChanges();
  }

  /**
   * For COD order and order with price as 0, we move to order success page.
   * Else opens the payment sdk for selected mode.
   */
  openPayment(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'pay-now' }));
    switch (this.selectedPaymentMode) {
      case this.appConfig.Shared.Payment.paymentModes.PAY_PAL:
      case this.appConfig.Shared.Payment.paymentModes.NET_BANKING:
      case this.appConfig.Shared.Payment.paymentModes.UPI:
      case this.appConfig.Shared.Payment.paymentModes.CARD:
      case this.appConfig.Shared.Payment.paymentModes.WALLET:
      case this.appConfig.Shared.Payment.paymentModes.OTHER:
      case this.appConfig.Shared.Payment.paymentModes.PAYTM: {
        if (this.orderSP > 0) this.payThrough(this.selectedPaymentMode);
        else this.moveToSuccessPage();
        break;
      }
      case this.appConfig.Shared.Payment.paymentModes.COD: {
        this.processCODPurchase();
        break;
      }
      default: break;
    }
  }

  processCODPurchase(): void {
    this.eventLogger.trackEvent('cod_order', { username: this.user.get('username') });
    this.eventLogger.trackInElasticSearch({ username: this.user.get('username'),
      added: new Date(),
      type: 'webApp',
      orderType: this.order.get('type'),
      orderId: this.order.id,
      message: 'User placed COD order',
      event: 'COD_ORDER' });
    this.moveToSuccessPage();
  }

  async moveToSuccessPage(): Promise<void> {
    // Fetch the order and get GokWik data, if any
    const order = new Table.Order();
    order.id = this.order.id;
    await order.fetch();
    const gokWikData = this.getGokWikData(order);

    // Show loading spinner and track event in analytics
    this.showLoadingSpinner();
    this.trackOrderSuccessEvent();

    // Navigate to success page
    this.navigateToSuccessPage(order, gokWikData);
  }

  private getGokWikData(order: any): any {
    let gokWikData = {};
    if (order.get('gokWik')?.create) {
      gokWikData = {
        request_id: order.get('gokWik').create.request_id,
        gokwik_oid: order.get('gokWik').create.gokwik_oid,
        total: order.get('amount'),
        moid: order.get('gokWik').create.moid,
        mid: order.get('gokWik').create.mid,
        phone: order.get('gokWik').create.phone,
        order_type: order.get('paymentType') === 'COD' ? 'cod' : 'non-gk',
      };
    }
    return gokWikData;
  }

  private showLoadingSpinner(): void {
    this.loading = true;
  }

  private trackOrderSuccessEvent(): void {
    this.eventLogger.trackEvent('order_success');
    this.eventLogger.trackInParse('ORDER_SUCCESSFUL', ApiClientConstant.Event.Type.ORDER);
  }

  private navigateToSuccessPage(order: any, gokWikData: any): void {
    const regimenId = order?.get('regimenId');
    this.router.navigate(
      ['/user/orders/success'],
      {
        queryParams: {
          orderId: order.id,
          orderType: order.get('type'),
          amount: order.get('amount'),
          gokWik: encodeURIComponent(JSON.stringify(gokWikData)),
          ...(regimenId && { regimenId }),
        },
      });
  }

  /**
   * Receives the 'key' payment key and sends to razorpay sdk with all other data to open the sdk payment page.
   * On failure retries 3 times to open the sdk.
   */
  openRazorpayPayment(payment: any, key: any, url: any, paymentMethod: string, retryCount: number = 3): void {
    const handleSuccess = (options: any): void => {
      if (!this.razorpayNativePayment || !this.appWebBridgeService.requestRazorpayPayment(options)) {
        this.razorpay = new this.windowRef.nativeWindow.Razorpay(options);
        this.razorpay.open();
      } else {
        this.broadcast.broadcast('LOADING', { status: false });
      }
      this.eventLogger.timeEvent('time_payment_initiate_to_complete');
    };

    const handleError = (err: any): void => {
      this.broadcast.broadcast('LOADING', { status: false });
      this.notify(err.message || err.toString());
    };

    const handleTimeout = (): void => {
      if (retryCount) {
        setTimeout((): void => this.openRazorpayPayment(payment, key, url, paymentMethod, retryCount - 1), 1000);
      } else {
        this.notify('Unable to open payment');
        this.broadcast.broadcast('LOADING', { status: false });
      }
    };

    this.eventLogger.trackEvent('payment_razorpay', { username: this.user.get('username') });
    this.trackRazorpayEvent('user selected razorpay payment');

    this.broadcast.broadcast('LOADING', { status: true });

    if (this.windowRef.nativeWindow.Razorpay) {
      this.getRazorpayOptions(payment, url, key, paymentMethod)
        .then(handleSuccess)
        .catch(handleError);
    } else {
      handleTimeout();
    }
  }

  private trackRazorpayEvent(event: any): void {
    if (event && event.detail && event.detail.event) {
      const eventType = event.detail.event;
      const eventData = event.detail.payload;
      this.eventLogger.trackEvent(`payment_razorpay_${eventType}`, { username: this.user.get('username') });
      this.eventLogger.trackInElasticSearch({ username: this.user.get('username'),
        added: new Date(),
        type: 'webApp',
        message: `razorpay event: ${eventType}`,
        event: `PAYMENT_RAZORPAY_${eventType}`,
        data: eventData });
    }
  }

  /**
   * We call api to generate hash for paytm payment for this order.
   * 1. We fill the payment hash config data in form and we submit it.
   * 2. Form data will hit the paytm server and load the paytm payment page on successful authentication.
   */
  openPaytmPayment(payment: any, url: any): void {
    this.trackPaytmPayment();
    this.generatePaytmHash(payment, url).subscribe((data: any): void => {
      this.paytmConfig = data;
      this.eventLogger.timeEvent('time_payment_initiate_to_complete');
      setTimeout((): void => this.submitPaytmForm(), 500);
    });
  }

  private trackPaytmPayment(): void {
    this.eventLogger.trackEvent('payment_paytm', { username: this.user.get('username') });
    this.eventLogger.trackInElasticSearch({
      username: this.user.get('username'),
      added: new Date(),
      type: 'webApp',
      message: 'User selected paytm payment',
      event: 'PAYMENT_PAYTM',
    });
  }

  private generatePaytmHash(payment: any, url: any): Observable<any> {
    return this.http.post(`${url}/api/paytm/generateHashForOrder`, {
      orderId: payment.id,
      url,
    });
  }

  private submitPaytmForm(): void {
    const form = this.windowRef.nativeWindow.document.formPaytm;
    if (form) {
      form.submit();
      this.broadcast.broadcast('LOADING', { status: false });
    }
  }

  /**
   * OTHER type - Opens the razorpay sdk home page with list of all possible payment options.
   */
  async openRazorpayHome(): Promise<void> {
    if (this.loading) return;
    this.loading = true;
    this.selectedPaymentMode = this.appConfig.Shared.Payment.paymentModes.OTHER;
    if (!this.isPaidUser) {
      this.updateOrderPrice();
      this.discount = Math.floor(((this.orderMRP - this.orderSP) * 100) / this.orderMRP);
    }
    await this.removePrepaidCouponIfNotUPI(this.selectedPaymentMode);
    this.loading = false;
    this.placeOrder();
  }

  /**
   * Checks the payment mode and redirects to specific sdk.
   * In case of paypal, if sends the payment.gatewayPayment which holds the gateway links of paypal payment page.
   */
  payThrough(paymentMode: string): void {
    if (!this.payment) {
      this.broadcast.broadcast('NOTIFY', { message: 'No payment found. Contact Team.' });
      return;
    }

    this.broadcast.broadcast('LOADING', { status: true });

    const url = this.conn.getParseUrl();
    const key = this.paymentSecretKey;

    this.trackPaymentEvents(paymentMode);
    const razorpayPaymentMethod = this.getRazorpayPaymentMethod(paymentMode);

    switch (paymentMode) {
      case this.appConfig.Shared.Payment.paymentModes.PAYTM:
        this.openPaytmPayment(this.payment, url);
        break;
      case this.appConfig.Shared.Payment.paymentModes.PAY_PAL:
        this.openPayPalPayment(this.payment.get('gatewayPayment'));
        break;
      default:
        this.openRazorpayPayment(this.payment, key, url, razorpayPaymentMethod, 3);
        break;
    }
  }

  private trackPaymentEvents(paymentMode: string): void {
    this.eventLogger.trackEvent('time_signup_to_payment_initiate', {});
    this.eventLogger.timeEvent('time_payment_initiate_to_complete', true);
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'payment' }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    this.appWebBridgeService.logEventInBranchAndFirebaseFromiOS({
      branch: { name: 'pageOpenPaymentPage' },
      firebase: { name: 'pageOpenPaymentPage' },
    });
  }

  private getRazorpayPaymentMethod(paymentMode: string): string {
    switch (paymentMode) {
      case this.appConfig.Shared.Payment.paymentModes.NET_BANKING:
        return 'netbanking';
      case this.appConfig.Shared.Payment.paymentModes.UPI:
        return 'upi';
      case this.appConfig.Shared.Payment.paymentModes.CARD:
        return 'card';
      case this.appConfig.Shared.Payment.paymentModes.WALLET:
        return 'wallet';
      default:
        return null;
    }
  }

  /**
   * Prepares the config json for razorpay sdk by setting the payment key and other data of user, order, payment mode,
   */
  async getRazorpayOptions(payment: any, url: any, key: any, paymentMethod: string): Promise<any> {
    const description = this.getDescription(payment);

    const options = {
      key,
      order_id: payment.get('razorpayOrderId'),
      callback_url: `${url}/api/razorpay/callbackForOrder`,
      amount: payment.get('TransactionAmount'),
      name: 'CureSkin',
      description,
      image: 'https://cdn.cureskin.com/app/img/logo-512.png',
      modal: {
        ondismiss: (): void => this.zone.run((): void => {
          this.broadcast.broadcast('LOADING', { status: false });
        }),
      },
      prefill: {
        contact: payment.get('UserMobileNumber') || this.user.get('MobileNumber'),
        email: payment.get('UserEmailId') || 'payments@cureskin.com',
        method: paymentMethod,
      },
      notes: this.getNotes(payment),
    };

    return Promise.resolve(options);
  }

  getDescription(payment: any): string {
    if (payment.get('preCondition')
      && payment.get('preCondition').includes(this.appConfig.Shared.Payment.PreCondition.COD_CONFIRMATION_FEE)) {
      return 'Cod Charges';
    }
    return `${payment.get('paymentPlan').charAt(0).toUpperCase()}${payment.get('paymentPlan').slice(1).toLowerCase()} Charges`;
  }

  getNotes(payment: any): any {
    return {
      order_number: this.order.get('orderNumber'),
      userId: payment.get('userId'),
      regimenId: payment.get('regimenId'),
      paymentType: payment.get('paymentPlan'),
      paymentTableObjectId: payment.id,
    };
  }

  /**
   * Shows the COD confirmation popup; on confirm, switches payment mode to UPI
   * and calls the api to initiate the order payment directly.
   */
  payCodConfirmationFee(): void {
    this.eventLogger.trackEvent(`PAY_COD_CONFIRMATION_FEE_${this.selectedPaymentMode}`,
      { type: ApiClientConstant.Event.Type.ORDER });
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'CCOD_bottom_sheet_pay_50' }));
    this.selectedPaymentMode = this.appConfig.Shared.Payment.paymentModes.UPI;
    this.changeDetection.detectChanges();
    this.openPayment();
  }

  notify(message: any, variant: NotificationVariant = NotificationVariant.DEFAULT): void {
    this.broadcast.broadcast('NOTIFY', { message, variant });
  }

  /**
   * 1. Fetches the coupons (of type NORMAL, USER_REFERRAL) applied to the order and store in appliedCoupon,
   *    which will not show apply coupon feature if its already applied.
   * 2. Fetches the applied wallet balance, which is a coupon of type 'CURE_SKIN_CASH'.
   * 3. we add the sum of coupon value + applied wallet balance value to SP price of order (not MRP).
   * 4. Finally discount is calculated.
   */
  calculateCouponDiscount(): void {
    const couponInfo = this.order.get('couponInfo') || [];
    this.appliedCoupon = couponInfo.find((coupon: any): boolean => [
      this.appConfig.Shared.Coupon.TYPE.NORMAL,
      this.appConfig.Shared.Coupon.TYPE.USER_REFERRAL,
    ].includes(coupon.type));
    // Explicitly set to undefined if no CURE_SKIN_CASH coupon found (when useCureSkinCash: false)
    this.appliedWalletBalance = couponInfo.find((coupon: any): boolean => [
      this.appConfig.Shared.Coupon.TYPE.CURE_SKIN_CASH,
    ].includes(coupon.type));
    const actualSP = this.orderSP + (this.appliedWalletBalance?.amount || 0) + (this.appliedCoupon?.amount || 0);
    this.orderActualSP = actualSP;
    if (this.order.get('type') === this.appConfig.Shared.Order.Type.REGIMEN) {
      if (this.isPrepaidDiscountEnabled) {
        this.discount = Math.floor(((this.orderMRP - this.orderSP) * 100) / this.orderMRP);
      } else {
        this.discount = Math.floor(((this.orderMRP - actualSP) * 100) / this.orderMRP);
      }
    } else {
      this.discount = Math.floor(((this.orderMRP - this.orderSP) * 100) / this.orderMRP);
    }
    if (this.appliedCoupon) {
      this.showCouponsSection = false;
    }
    this.updateWalletOrCashUI();
  }

  /**
   * Applies coupon to the order adn we re-fetch the order to re-calculate discount on latest order data.
   */
  async applyCoupon(paymentMode: any = '', skipToastMessage: boolean = false): Promise<any> {
    if (!this.couponCode || this.couponLoading) return;
    try {
      this.couponLoading = true;
      await this.conn.applyDiscountWith(this.couponCode, this.order.id);
      if (!skipToastMessage) this.notify('Coupon Applied');
      const checkoutPayload = this.buildCheckoutPayloadWithStoredUseCureSkinCash(this.order.id);
      this.order = await this.conn.checkoutAndCreateOrder(checkoutPayload);
      await this.processOrderData(paymentMode);
      this.orderSP = this.order.get('amount') - (this.order.get('paidAmount') || 0);
      this.calculateCouponDiscount();
    } catch (err) {
      const error = JSON.parse(JSON.stringify(err));
      this.notify(error?.message || err.toString());

      Promise.reject(err);
    } finally {
      this.couponLoading = false;
    }
    this.changeDetection.detectChanges();
  }

  /**
   * Process the gateway links and filters the approved one and sends to android to open the link in a new tab.
   * Else opens in web browser.
   */
  private async openPayPalPayment(payPalResponse: any): Promise<any> {
    const { href }: any = payPalResponse.links.find((each: any): boolean => each.rel === 'approve');
    const approvalURL = `${href}&locale.x=en_IN&country.x=IN`;
    this.eventLogger.timeEvent('time_payment_initiate_to_complete');
    if (this.appWebBridgeService.requestOpenInOverlayWindow(approvalURL)) {
      return;
    }
    this.windowRef.nativeWindow.location = approvalURL;
  }

  openCouponsSection(): void {
    this.showCouponsSection = true;
    setTimeout((): void => {
      this.couponInput.nativeElement.focus();
    });
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'apply-coupon' }));
    if (this.paymentPage?.nativeElement) {
      setTimeout((): void => this.paymentPage.nativeElement?.scroll(0, this.paymentPage.nativeElement.scrollHeight));
    }
  }

  showOrderDetailsPopup(): void {
    const products = this.order.get('productInfo');
    this.orderSummary = {
      products,
      services: this.order.get('services'),
      totalSP: this.orderSP,
      totalMRP: this.orderMRP,
    };
    this.popUp.open = true;
    this.popUp.type = 'ORDER_SUMMARY';
  }

  showCodConfirmationFeePopup(): void {
    this.popUp.open = true;
    this.popUp.data = this.payment;
    this.popUp.orderData = this.order;
    this.popUp.data.total = this.orderSP;
    this.popUp.type = 'COD_CONFIRMATION';
    const ccodRef = this.bottomSheet.open(CCODBottomSheetComponent, {
      data: {
        popupData: this.popUp.data,
        orderData: this.popUp.orderData,
        isCCODChargeApplicable: this.showCCODCharge,
        callback: (): void => {
          this.payCodConfirmationFee();
        },
      },
    });
    ccodRef.afterDismissed().subscribe((): void => {
      this.ccodPopupSeen = true;
    });
  }

  /**
   * If razorpay popup is open, wwe close the popup annd then go back.
   */
  async handleBackPress(): Promise<boolean> {
    if (this.razorpay && this.razorpay.close) {
      this.razorpay.close();
      this.locationService.back();
      return Promise.resolve(true);
    }
    if (this.shouldShowSharePaymentBackPopup()) {
      this.openSharePaymentBackPopup();
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }

  /**
   * The "Can't Pay Online?" nudge shows once per session, only after an acquisition user
   * has seen and dismissed the CCOD fee popup, when they try to leave the payment page.
   */
  shouldShowSharePaymentBackPopup(): boolean {
    return this.backPopupEnabled
      && this.ccodPopupSeen
      && !this.isIOSDevice
      && this.orderSP > 0
      && !this.paymentService.getSharePaymentBackPopupState(this.order?.id);
  }

  openSharePaymentBackPopup(): void {
    this.paymentService.setSharePaymentBackPopupShown(this.order?.id);
    const isCCODEligible = this.order?.get('paymentGateway').includes(this.appConfig.Shared.Payment.paymentModes.CCOD);
    const ref = this.bottomSheet.open(SharePaymentHowItWorksComponent, {
      data: {
        backPopup: true,
        orderSP: this.orderSP,
        isCCODEligible,
        onGenerateLink: (): void => {
          this.openPaymentLinkGeneratedSheet();
        },
        onShareDirectly: (): void => {
          this.triggerNativeShareAndOpenSharedSheet();
        },
      },
    });
    // Close/back inside the popup returns 'NAVIGATE_BACK' -> leave the page;
    // a backdrop tap dismisses with no result -> stay on the payment page.
    ref.afterDismissed().subscribe((result: string): void => {
      if (result === 'NAVIGATE_BACK') {
        this.locationService.back();
      }
    });
  }

  /**
   * We close the razorpay popup and empty the cart products.
   */
  ngOnDestroy(): void {
    if (this.razorpay && this.razorpay.close) {
      this.razorpay.close();
    }
    this.store.dispatch(fromActions.CartUpdateProductsBegin({ products: {} }));
  }

  logSharePaymentLinkImpression(): void {
    this.eventLogger.cleverTapEvent('impression', JSON.stringify({ name: 'share_payment_link_shown' }));
  }

  openSharePaymentLinkSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'share_payment_link_clicked' }));
    const isCCODEligible = this.order?.get('paymentGateway').includes(this.appConfig.Shared.Payment.paymentModes.CCOD);
    this.bottomSheet.open(SharePaymentHowItWorksComponent, {
      data: {
        orderSP: this.orderSP,
        isCCODEligible,
        onGenerateLink: (): void => {
          this.openPaymentLinkGeneratedSheet();
        },
        onShareDirectly: (): void => {
          this.triggerNativeShareAndOpenSharedSheet();
        },
      },
    });
  }

  openPaymentLinkGeneratedSheet(): void {
    this.bottomSheet.open(SharePaymentLinkGeneratedComponent, {
      data: {
        orderSP: this.orderSP,
        codFee: this.CCODInfo?.amount || 0,
        onShare: (isPartialPayment?: boolean): void => {
          this.triggerNativeShareAndOpenSharedSheet(isPartialPayment);
        },
      },
    });
  }

  async triggerNativeShareAndOpenSharedSheet(isPartialPayment?: boolean): Promise<void> {
    const { shortUrl } = await this.conn.createPaymentLink(this.order.id, isPartialPayment);
    await this.appWebBridgeService.shareTextThroughSupportedApps(shortUrl);
    const sharedAmount = isPartialPayment ? (this.CCODInfo?.amount || 0) : this.orderSP;
    this.bottomSheet.open(SharePaymentLinkSharedComponent, {
      data: { orderSP: sharedAmount, paymentLink: shortUrl },
    });
  }

  back(): void {
    sessionStorage.setItem('fromPaymentPage', 'true');
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  handleBottomSheetDismiss(ref: MatBottomSheetRef<any>): void {
    ref.afterDismissed().subscribe((): void => {
      this.loading = false;
      this.changeDetection.detectChanges();
    });
  }

  async toggleApplyCash(): Promise<void> {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: 'apply_cash_payment_page',
      toggle: this.applyCashSelected,
    }));

    // Only allow enabling cash, not disabling (one-way toggle)
    if (this.applyCashSelected || !this.order?.id) {
      return;
    }

    try {
      this.loading = true;
      this.applyCashSelected = true;
      const orderId = this.order.id;
      // Store the preference in sessionStorage
      sessionStorage.setItem(`useCureSkinCash_${orderId}`, 'true');

      // Call checkoutAndCreateOrder with useCureSkinCash: true
      this.order = await this.conn.checkoutAndCreateOrder({
        orderId,
        useCureSkinCash: true
      });

      // Refresh the order data and recalculate
      await this.processOrderData(this.selectedPaymentMode);
      this.orderSP = this.order.get('amount') - (this.order.get('paidAmount') || 0);
      this.calculateCouponDiscount();
      // Sync applyCashSelected with the actual state after API call
      this.applyCashSelected = !!this.appliedWalletBalance;
      // Show confetti animation
      this.showConfettiAnimation = true;
      setTimeout(() => {
        this.showConfettiAnimation = false;
        this.changeDetection.detectChanges();
      }, 600);
      this.changeDetection.detectChanges();
    } catch (error) {
      // Revert the toggle on error
      this.applyCashSelected = false;
      this.notify(error?.message || 'Failed to apply wallet balance');
    } finally {
      this.loading = false;
      this.changeDetection.detectChanges();
    }
  }

  private isProductOrder(): boolean {
    return this.order.get('type') === this.appConfig.Shared.Order.Type.PRODUCT;
  }

  private isPaymentModeCOD(): boolean {
    return this.selectedPaymentMode === this.appConfig.Shared.Order.PaymentType.COD;
  }
}
